const decodeFromURI = (content) => decodeURIComponent(content.replace(/\+/g, '%20'));
const generateSrcSet = (urls) => {
  return urls === null || urls === void 0 ? void 0 : urls.join(',');
};

export { decodeFromURI as d, generateSrcSet as g };
